var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 143,
    viewBox: "0 0 174 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5725 5C83.3937 19.038 74.5059 47.0068 40.3854 46.5777",
    stroke: "#677788",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3043 5C83.4842 19.127 92.4272 47.2729 126.76 46.841",
    stroke: "#677788",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.28 41.2594C10.3549 47.3174 7.80862 73.8818 9.77615 86.4068L78.6975 67.9394C75.3605 56.5219 62.2052 35.2015 36.28 41.2594Z",
    fill: "#F0AE00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9777,
    cy: 77.2425,
    rx: 35.6763,
    ry: 6.97432,
    transform: "rotate(-15 43.9777 77.2425)",
    fill: "#E0A200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.088 40.4918C115.608 32.7756 100.12 54.5079 95.5617 66.3386L164.483 84.806C167.302 73.2497 166.569 48.208 141.088 40.4918Z",
    fill: "#F0AE00"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.763,
    cy: 75.5029,
    rx: 35.6763,
    ry: 6.97432,
    transform: "rotate(15 129.763 75.5029)",
    fill: "#E0A200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.7426,
    y: 87.6223,
    width: 7.5108,
    height: 13.5738,
    rx: 3.7554,
    transform: "rotate(-12.7787 59.7426 87.6223)",
    fill: "#5BC597"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0339,
    y: 95.718,
    width: 7.5108,
    height: 13.5738,
    rx: 3.7554,
    transform: "rotate(-12.7787 94.0339 95.718)",
    fill: "#FFABAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8745,
    y: 82.3058,
    width: 7.5108,
    height: 13.5738,
    rx: 3.7554,
    transform: "rotate(-12.7787 32.8745 82.3058)",
    fill: "#97B1F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1407,
    y: 128.98,
    width: 7.5108,
    height: 13.5923,
    rx: 3.7554,
    transform: "rotate(-12.7787 44.1407 128.98)",
    fill: "#97B1F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112.873,
    y: 90.8377,
    width: 7.5108,
    height: 14.9933,
    rx: 3.7554,
    transform: "rotate(16.8796 112.873 90.8377)",
    fill: "#97B1F1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4008,
    y: 103.177,
    width: 7.5108,
    height: 19.85,
    rx: 3.7554,
    transform: "rotate(22.9658 37.4008 103.177)",
    fill: "#5BC597"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7245,
    y: 116.856,
    width: 7.5108,
    height: 19.85,
    rx: 3.7554,
    transform: "rotate(-32.3825 52.7245 116.856)",
    fill: "#FFABAB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128.369,
    y: 91.0232,
    width: 7.5108,
    height: 19.85,
    rx: 3.7554,
    transform: "rotate(-18.0838 128.369 91.0232)",
    fill: "#FFABAB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 119.883,
    y: 116.589,
    width: 7.5108,
    height: 11.4224,
    rx: 3.7554,
    transform: "rotate(31.6824 119.883 116.589)",
    fill: "#FFABAB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 144.637,
    y: 120.344,
    width: 7.5108,
    height: 19.85,
    rx: 3.7554,
    transform: "rotate(35.1922 144.637 120.344)",
    fill: "#5BC597"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.375,
    y: 68.8418,
    width: 7.5108,
    height: 19.85,
    rx: 3.7554,
    transform: "rotate(35.1922 111.375 68.8418)",
    fill: "#5BC597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportProgress);
export default __webpack_public_path__ + "static/media/import-progress.3583182730d76ab0ab4ca40d398f971d.svg";
export { ForwardRef as ReactComponent };